import { forwardRef, useState } from 'react'
import AvatarEditor from 'react-avatar-editor'
import { gemoji } from 'gemoji'
import { toast } from 'react-toastify'

import { Button as btn } from '../uiKit'
import closeIcon from '../../assets/svg/icon_close_cross.svg'
import { EmojiData } from '../../pages/AddAnimatedStickers'

import './styles.scss'

interface StickerEditorProps {
  editableSticker: File
  onDone: (str: EmojiData) => void
  onClose: () => void
}

const Button = btn as any

export const StickerEditor = forwardRef<AvatarEditor, StickerEditorProps>(
  function AvatarImageEditor({ editableSticker, onDone, onClose }, ref) {
    const [scale, setScale] = useState(1)
    const [correspondingEmogi, setCorrespondingEmogi] =
      useState<EmojiData | null>(null)

    const done = () => {
      console.log('🚀 ~ correspondingEmogi:', correspondingEmogi)
      if (correspondingEmogi) {
        onDone(correspondingEmogi)
      } else {
        toast('Please select an imoji to continue adding this sticker')
      }
    }

    const handleChangeScale = (e: React.ChangeEvent<HTMLInputElement>) => {
      setScale(+e.currentTarget.value)
    }

    return (
      <div className="sticker-editor">
        <button
          type="button"
          className="sticker-editor--close"
          onClick={onClose}
        >
          <img src={closeIcon} alt="" />
        </button>

        <div className="sticker-editor--panel">
          <div className="sticker-editor--view">
            <img
              className="w-full h-full"
              width={512}
              height={512}

              src={URL.createObjectURL(editableSticker)}
              alt=""
            />
            {/* <AvatarEditor
              ref={ref}
              image={editableSticker}
              // scale={scale}
              width={512}
              height={512}
              className="sticker-editor--canvas"
              border={0}
            /> */}
          </div>

          <div className="sticker-editor--toolbar">
            {/* <div>
              <div>Scale:</div>
              <input
                type="range"
                className="sticker-editor--range"
                min={0.5}
                max={2}
                step={0.01}
                value={scale}
                name="rabge"
                onChange={handleChangeScale}
              />
            </div> */}

            <div className="emoji-matcher">
              {gemoji.map((e) => {
                const name = e.names[0]
                return (
                  <button
                    onClick={() =>
                      setCorrespondingEmogi({ emoji: e.emoji, emojiName: name })
                    }
                    type="button"
                    key={name}
                    className={`emoji-matcher--btn ${
                      name === correspondingEmogi?.emojiName
                        ? 'emoji-matcher--btn-active'
                        : ''
                    }`}
                  >
                    {e.emoji}
                  </button>
                )
              })}
            </div>

            <div className="sticker-editor--done-btn">
              <Button onClick={done}>Done</Button>
            </div>
          </div>
        </div>
      </div>
    )
  },
)
